import { render, staticRenderFns } from "./Navbar.FeedCategories.vue?vue&type=template&id=70861ba9&scoped=true&"
import script from "./Navbar.FeedCategories.vue?vue&type=script&lang=js&"
export * from "./Navbar.FeedCategories.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.FeedCategories.vue?vue&type=style&index=0&id=70861ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70861ba9",
  null
  
)

export default component.exports